import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ChartBar } from "@phosphor-icons/react";
import api from "@/lib/api";
import { pts, tzs, fmtDateTime } from "@/lib/format";

export default function StaffToday() {
  const nav = useNavigate();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/staff/today").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return <div className="pt-10 text-center text-muted-foreground">Loading…</div>;

  return (
    <div className="space-y-5">
      <button onClick={() => nav("/staff")} className="text-muted-foreground flex items-center gap-1 text-sm"><ArrowLeft size={16} /> Home</button>
      <h1 className="font-display font-bold text-2xl flex items-center gap-2"><ChartBar size={24} className="text-primary" /> Today's activity</h1>

      <div className="grid grid-cols-3 gap-3">
        <div className="card-surface p-4 text-center"><p className="font-display font-bold text-2xl">{d.customers}</p><p className="text-[10px] text-muted-foreground">Customers</p></div>
        <div className="card-surface p-4 text-center"><p className="font-display font-bold text-2xl text-primary">{pts(d.points_issued)}</p><p className="text-[10px] text-muted-foreground">Points</p></div>
        <div className="card-surface p-4 text-center"><p className="font-display font-bold text-2xl">{d.redemptions}</p><p className="text-[10px] text-muted-foreground">Redeemed</p></div>
      </div>

      <div className="space-y-2">
        {d.transactions.length === 0 && <p className="text-sm text-muted-foreground">No transactions yet today.</p>}
        {d.transactions.map((t) => (
          <div key={t.id} data-testid="today-txn" className="card-surface p-3.5 flex items-center justify-between">
            <div>
              <p className="text-sm font-medium">{t.customer_name}</p>
              <p className="text-xs text-muted-foreground capitalize">{t.type === "purchase" ? tzs(t.purchase_amount) : t.reward_name || t.type} · {fmtDateTime(t.created_at)}</p>
            </div>
            <span className={`font-display font-bold ${t.type === "redemption" ? "text-destructive" : "text-primary"}`}>
              {t.type === "redemption" ? `-${pts(t.points_spent)}` : `+${pts(t.points_awarded)}`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
